import styled from 'styled-components';
import styles from '../../../styles';

const ColumnContent = styled.div`
  box-sizing: border-box;
  padding-top: ${props => props.paddingTop || '0'};
  padding-bottom: ${props => props.paddingBottom || '0'};
  padding-left: ${props => props.paddingLeft || '3.75rem'};
  padding-right: ${props => props.paddingRight || '3.75rem'};
  ${styles.media.tablet`
    padding-left: ${props => props.paddingLeft || '1.875rem'};
    padding-right: ${props => props.paddingRight || '1.875rem'};
  `}
  ${styles.media.phone`
    padding-left: 0;
    padding-right: 0;
  `}
  h2 {
    margin-bottom: 2rem;
    color: ${styles.color.BLACK};
  }

  h3 {
    color: ${styles.color.SLATE};
    font-family: ApercuMono;
    text-transform: uppercase;
    margin-bottom: 1rem;
  }
`;

export default ColumnContent;



// WEBPACK FOOTER //
// ./src/modules/layout/components/ColumnContent.js